// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IdeaPointOut } from './ideaPointOut.zod.ts';

export const IdeaPointsOut = zod.object({
  "counts": zod.record(zod.string(), zod.int()),
  "points": zod.array(IdeaPointOut),
  "total": zod.int(),
  "verdict_counts": zod.record(zod.string(), zod.int())
});

export type IdeaPointsOut = zod.input<typeof IdeaPointsOut>;
export type IdeaPointsOutOutput = zod.output<typeof IdeaPointsOut>;
